import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { DeviceListFeatureGate } from '../Guards/DeviceListFeatureGate'
import { DeviceList } from '../Components/Organisms/DeviceList/DeviceList'

/**
 * Routed Devices list page.
 */
@Route(RouteID.DEVICE)
export class DeviceListPage extends Component {
    /**
     * @returns Devices list page tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.DEVICE}>
                <DeviceListFeatureGate>
                    <LanguageContextProvider>
                        <DeviceList />
                    </LanguageContextProvider>
                </DeviceListFeatureGate>
            </RouteGuard>
        )
    }
}
